module.exports = __webpack_public_path__ + "img/WCA危险品专项会员2025.9bdeb176.jpg";